module.exports = __webpack_public_path__ + "img/上海来利.png";